import React, { Component } from 'react'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import Style from './style.module.less'

class ExtensionDuration extends Component {
  operate = type => () => {
    const { onChange, value, min } = this.props
    let time = value
    if (type === 'minus' && time > min) {
      time = time - 15
    } else if (type === 'plus') {
      time = time + 15
    }
    onChange && onChange(time)
  }

  render() {
    const { value, description } = this.props
    return (
      <>
        <div className={Style['count-wrapper']}>
          <div className={Style.count}>
            <div className={Style.minus} onClick={this.operate('minus')}>
              <MinusOutlined />
            </div>

            <div className={Style.time}>{value}</div>
            <div className={Style.plus} onClick={this.operate('plus')}>
              <PlusOutlined />
            </div>
          </div>

          <div className={Style.stress}>分钟</div>
        </div>
        <div className={Style.tip}>{description}</div>
      </>
    )
  }
}

export default ExtensionDuration
